{
  "name": "admin-ui",
  "version": "2.1.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 6006",
    "start:es-ES": "ng serve --configuration=es-ES",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "test": "jest --verbose",
    "test:coverage": "jest --coverage",
    "test:watch": "jest --watch",
    "test-headless": "jest --runInBand --detectOpenHandles --forceExit --ci --coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.12",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.12",
    "@angular/compiler": "^17.3.12",
    "@angular/core": "^17.3.12",
    "@angular/forms": "^17.3.12",
    "@angular/material": "^17.3.10",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.12",
    "@angular/router": "^17.3.12",
    "@hygie31/keycloak-authentication": "^0.0.1",
    "@hygie31/ngx-hygie31-kit-ui-17": "^0.1.14",
    "@ngx-translate/http-loader": "^7.0.0",
    "fast-xml-parser": "^4.3.1",
    "file-saver": "^2.0.5",
    "keycloak-angular": "^15.3.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.11",
    "@angular-eslint/builder": "17.5.2",
    "@angular-eslint/eslint-plugin": "17.5.2",
    "@angular-eslint/eslint-plugin-template": "17.5.2",
    "@angular-eslint/schematics": "17.5.2",
    "@angular-eslint/template-parser": "17.5.2",
    "@angular/cli": "~17.3.11",
    "@angular/compiler-cli": "^17.3.12",
    "@angular/localize": "^17.3.12",
    "@types/file-saver": "^2.0.5",
    "@types/jest": "^29.5.12",
    "@typescript-eslint/eslint-plugin": "7.2.0",
    "@typescript-eslint/parser": "7.2.0",
    "eslint": "^8.57.0",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.4.2",
    "ts-jest": "^29.1.4",
    "typescript": "^5.4.5"
  }
}
